module.exports = __webpack_public_path__ + "static/media/title-hero-3.9eafde0a.jpg";